import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import LogoWhite from '@kpmg-uk/tti-design-styles/dist/assets/images/logo-white.svg';
import NavbarToggle from '@kpmg-uk/tti-design-styles/dist/assets/images/navbar-toggler.svg';

import { getGlobalStyleSheets } from '../../global-styles';

import '../placeholders';
import '../sidebar';
import { ToggleSidebarEvent } from '../sidebar/events';

import * as TagNames from './main-header.tagnames';
import { AtlMainHeaderProps } from './main-header.props';
import { IClassMap } from '../helpers';
import { classMap } from 'lit/directives/class-map.js';

@customElement(TagNames.MainHeader)
export class AtlMainHeader extends LitElement implements AtlMainHeaderProps {
   declare appName?: string;
   declare showPlaceholder?: boolean;
   declare mainHeaderClassName?: string;

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         slot[name='NavStatusBarContainer'] {
            display: flex !important;
            flex-direction: row !important;
            align-items: center;
            gap: 0.5rem;
         }
      `,
   ];

   static properties = {
      appName: { attribute: 'app-name', type: String },
      showPlaceholder: { attribute: 'show-placeholder', type: Boolean },
      mainHeaderClassName: {
         attribute: 'main-header-class-name',
         type: String,
      },
   };

   private _renderNavbarHeaderContent = () => {
      if (this.showPlaceholder) {
         return html`
            <span class="app-title">
               <atlantis-span-placeholder
                  size="larger"
                  glow
               ></atlantis-span-placeholder>
            </span>
         `;
      }

      return html`
         <slot name="TitleContainer">
            <span class="app-title">${this.appName}</span>
         </slot>
      `;
   };

   private _renderSidebarToggle = () => {
      return html`
         <button
            class="navbar-toggler sidebar-stripe-navbar-toggler"
            type="button"
            aria-label="Toggle navigation"
            @click="${this._handleToggleClick}"
         >
            <img
               height="32"
               width="32"
               src="${NavbarToggle}"
               alt="Menu Toggle"
            />
         </button>
      `;
   };

   render() {
      const classNames: IClassMap = { mainheader: true };

      if (this.mainHeaderClassName) {
         this.mainHeaderClassName
            .split(' ')
            .forEach((cn) => (classNames[cn] = true));
      }

      return html`
         <section class=${classMap(classNames)}>
            <div class="container-fluid px-5">
               <nav class="navbar navbar-expand-lg p-0">
                  <div class="container-fluid p-0">
                     <div class="navbar-header">
                        ${this._renderSidebarToggle()}
                        <div class="header-brand">
                           <a href="/" class="brand-link">
                              <img
                                 class="logo"
                                 src="${LogoWhite}"
                                 alt="Image for KPMG logo"
                              />
                           </a>
                           ${this._renderNavbarHeaderContent()}
                        </div>
                        <slot name="GlobalSearchContainer"></slot>
                        <div class="nav-status-bar">
                           <slot name="NavStatusBarContainer"></slot>
                        </div>
                     </div>
                  </div>
               </nav>
            </div>
         </section>
      `;
   }

   private _handleToggleClick = () =>
      this.dispatchEvent(new ToggleSidebarEvent());
}
